// /fastDevice/channel_list — 反编译 StoreVideoListFragment.prepareForNoPublicChannel
// iOS app 用此接口拿"可播放通道"，与 /device/store_device_list_with_status (返回所有设备记录)
// 不同：它已经把 NVR 展开为通道、过滤掉无 channel_id 的死设备，结果与 iOS UI 一致。
import { callInternal } from './internal.js';

export interface FastChannel {
	device_auto_id: string;     // 数据库主键（用于改名 channel_edit）
	device_id: string;          // 真实 SN，喂给 /play/weburl
	channel_id: string;         // '1' / '2' ...
	channel_status: 0 | 1;      // 1 = 通道在线
	device_status: 0 | 1;       // 1 = 整机在线
	device_type_id: number;     // 3=普通摄像头 2=NVR 7=语音 88=蓝牙音视频
	alias?: string;             // 别名（"进店客流" 等），可空
	store_id: string;
	nvr_id?: string;            // 若是 NVR 子通道则非空
	nvr_sn?: string;
	nvr_channel_id?: string;
	sharedevice_flag?: 0 | 1;   // 共享设备
	upload_rate?: string;
	create_time?: string;
	offline_time?: string | null;
	has_yuzhiweis?: 0 | 1;
	property_id?: string;
	is_bind_bluetooth?: 0 | 1;
	index?: number;
}

export interface FetchFastChannelsOptions {
	withOfflineTime?: boolean;
	withYuzhiweiStatus?: boolean;
}

export async function fetchFastChannels(storeId: string, opts: FetchFastChannelsOptions = {}): Promise<FastChannel[]> {
	const body: Record<string, string | number> = { store_id: storeId };
	if (opts.withOfflineTime) body.with_offline_time = 1;
	if (opts.withYuzhiweiStatus) body.with_yuzhiwei_status = 1;
	const res = await callInternal<FastChannel[]>({
		short_name: 'base',
		action: '/fastDevice/channel_list',
		method: 'POST',
		body,
	});
	if (Number(res.code) === 0 && Array.isArray(res.data)) return res.data;
	throw new Error(`${res.msg || 'channel_list failed'} (code=${res.code})`);
}

/** 兼容旧 Device 接口 — 把 fastDevice 通道压成 Device 形状给老代码用 */
export interface DeviceLite {
	device_id: number | string;
	sn?: string;
	name?: string;
	store_id?: string;
	status?: number | string;
	type_id?: number | string;
	channel_id?: string;
	auto_id?: string;
	device_status?: number | string;
	offline_time?: string | null;
	has_yuzhiweis?: number | string;
}

export function fastChannelToDevice(ch: FastChannel): DeviceLite {
	return {
		device_id: ch.device_auto_id,
		auto_id: ch.device_auto_id,
		sn: ch.device_id,
		name: ch.alias,
		store_id: ch.store_id,
		status: ch.channel_status,    // 通道粒度的在线状态
		device_status: ch.device_status,
		type_id: ch.device_type_id,
		channel_id: ch.channel_id,
		offline_time: ch.offline_time,
		has_yuzhiweis: ch.has_yuzhiweis,
	};
}
